"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.HeatAbilityHandler = exports.HeatActorAbilityFactory = exports.HeatAbilityArgs = void 0;
const AbilityType_1 = require("../../core/abilities/AbilityType");
const ActorAbilityState_1 = require("../../core/actors/ActorAbilityState");
const Registries_1 = require("../../core/state/Registries");
const Target_1 = require("../../core/Target");
const Duration_1 = require("../../core/Duration");
const core_1 = require("../../core/effects/core");
const enums_1 = require("../../core/enums");
const Random_1 = require("../../utils/Random");
const AbilityDamage_1 = require("../../core/AbilityDamage");
const Array_1 = require("../../utils/Array");
class HeatAbilityArgs {
    constructor(target) {
        this.target = target;
        this.__type = AbilityType_1.AbilityType.Heat;
        this.__typeName = "Heat";
    }
}
exports.HeatAbilityArgs = HeatAbilityArgs;
let HeatActorAbilityFactory = class HeatActorAbilityFactory {
    mk() {
        return new ActorAbilityState_1.ActorAbilityState("Heat", "AllEnemies", 0);
    }
};
HeatActorAbilityFactory = __decorate([
    Registries_1.ActorAbilities.register("Heat")
], HeatActorAbilityFactory);
exports.HeatActorAbilityFactory = HeatActorAbilityFactory;
let HeatAbilityHandler = class HeatAbilityHandler {
    init(sequence, container, actorId) { }
    activate(sequence, container, ability) {
        container.applyMultiAttack({
            sequence,
            abilityKey: ability.args.__typeName,
            attackType: "magic",
            attackerId: ability.invokerId,
            targets: (0, Array_1.shuffle)(container.selectLivingTargets(ability.invokerId, Target_1.Target.AllEnemies))
                .map((targetId, i) => ({
                targetId,
                jitter: (0, Random_1.random)(25, 75),
                damages: [
                    AbilityDamage_1.AbilityDamage.Focus("Fire", 120)
                ],
                effects: [
                    {
                        targetId,
                        duration: Duration_1.Duration.Permanent,
                        // 50 -> 100 -> 150 -> 200
                        effect: new core_1.LinkedEffectsEffectArgs([
                            new core_1.BurningEffectArgs("Focus", 50 + 50 * i),
                            new core_1.MaxAttributeDecreaseEffectArgs(enums_1.AttributeType.FireDamageImmunity, 1 + i)
                        ], true)
                    },
                    {
                        targetId,
                        duration: Duration_1.Duration.Permanent,
                        effect: new core_1.MaxAttributeDecreaseEffectArgs(enums_1.AttributeType.FireDamageResistance, 25),
                        supernatural: true
                    }
                ]
            }))
        });
    }
};
HeatAbilityHandler = __decorate([
    Registries_1.Abilities.register(AbilityType_1.AbilityType.Heat)
], HeatAbilityHandler);
exports.HeatAbilityHandler = HeatAbilityHandler;
